import React from "react"
import styled from "styled-components"
import useLinksCollection from "../../../../hooks/useLinksCollection"
import useTopicCollection from "../../../../hooks/useTopicCollection"
import { breakpoints } from "../../../../theme"
import * as Icons from "@bw/icons"
import { useTranslation } from "react-i18next"

const Links = () => {
  const { t } = useTranslation()
  const topics = useTopicCollection()
  const allTopics = [
    { id: null, title: "Général", icon: { value: null } },
    ...topics,
  ]
  const { byTopic } = useLinksCollection()
  return (
    <Grid>
      {allTopics.map(topic => {
        const inTopic = byTopic.reduce((acc, link) => {
          const isInTopic =
            link.topics.map(t => t.id).includes(topic.id) ||
            (link.topics.length === 0 && topic.id === null)

          if (!isInTopic) {
            return acc
          }

          const publicTarget = link.public?.slug || "general"

          if (typeof acc[publicTarget] === "undefined") {
            acc[publicTarget] = []
          }

          acc[publicTarget].push(link)

          return acc
        }, {})

        if (inTopic === {}) {
          return null
        }

        const Icon =
          typeof Icons[topic.icon.value] !== "undefined"
            ? Icons[topic.icon.value]
            : Icons.Vide

        return (
          <Topic key={topic.id}>
            <Icon />
            <h3>{topic.title}</h3>
            <LinkGrid>
              {inTopic.general && (
                <div className="all-publics">
                  <ul>
                    {inTopic.general.map((link, i) => (
                      <li key={i}>
                        <a
                          href={link.externalLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {link.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {inTopic.parents && (
                <div>
                  <b>{t("parents")}</b>
                  <ul>
                    {inTopic.parents.map((link, i) => (
                      <li key={i}>
                        <a
                          href={link.externalLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {link.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {inTopic.jeune && (
                <div>
                  <b>{t("children")}</b>
                  <ul>
                    {inTopic.jeune.map((link, i) => (
                      <li key={i}>
                        <a
                          href={link.externalLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {link.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </LinkGrid>
          </Topic>
        )
      })}
    </Grid>
  )
}

const Grid = styled.div`
  @media (min-width: ${breakpoints.medium}px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }
`

const Topic = styled.div`
  padding: 20px 0 0;
  font-size: 14px;

  h3 {
    margin: 0 0 5px;
  }
`

const LinkGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;

  .all-publics {
    grid-column: span 2;
  }

  ul {
    margin: 5px 0 0;
    padding: 0;
    list-style-type: none;
  }

  li + li {
    margin-top: 5px;
  }

  a:not([class]) {
    border-color: transparent;

    &:hover {
      border-color: var(--secondary);
    }
  }
`

export { Links }
